import {
  EnergyEfficiencyFlag,
  type EnergyEfficiencyFlagProps,
} from '../../components/EnergyEfficiencyFlag/EnergyEfficiencyFlag';
import { DownloadItem } from '../../../DownloadItem/DownloadItem.client';
import { EfficiencyFlagOverlayDialog } from '../../components/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog.client';
import type { EnergieEfficiency, EnergieEfficiencyOld } from '../../types';

/**
 * Props for rendering a single energy efficiency flag item.
 *
 * Combines the flag data with optional description text and an additional datasheet link.
 */
export type EnergyEfficiencyFlagItemProps = (EnergieEfficiency | EnergieEfficiencyOld) & {
  linkToEnergieEfficiencyLabel: string;
  size?: EnergyEfficiencyFlagProps['size'];
  flagDescription?: string;
  overlayTitle?: string;
  dataSheetUrl?: string;
};

/**
 * Renders the energy efficiency flag with an overlay dialog and optional datasheet link.
 *
 * The wrapper decides how this component will be rendered (see stories for examples).
 */
export const EnergyEfficiencyFlagItem = ({
  flagDescription,
  overlayTitle,
  dataSheetUrl,
  ...props
}: EnergyEfficiencyFlagItemProps) => (
  <>
    <div className="[&>button]:block">
      <EfficiencyFlagOverlayDialog
        overlay={{
          title: flagDescription || overlayTitle || '',
          imgUrl: props.linkToEnergieEfficiencyLabel,
        }}
      >
        <EnergyEfficiencyFlag {...props} />
      </EfficiencyFlagOverlayDialog>
    </div>
    <div className="[&>a]:block">
      {flagDescription && <div className="text-size-body-sm">{flagDescription}</div>}
      {dataSheetUrl && (
        <DownloadItem link={dataSheetUrl} type="PRODUCT_DATASHEET" renderIcon={false} />
      )}
    </div>
  </>
);
